module.exports = __webpack_public_path__ + "static/media/project1.4ba63ce0.png";